import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const TestPaperCategoryService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 试卷分类分页
     */
    testPaperCategoryPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaperCategory/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 试卷分类列表
    */
    testPaperCategoryList({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaperCategory/list').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试卷分类
    */
    testPaperCategoryGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaperCategory/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试卷分类详情
    */
    testPaperCategoryGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'testPaperCategory/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 试卷分类保存
     */
    testPaperCategorySave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaperCategory/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷分类更新
     */
    testPaperCategoryUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaperCategory/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试卷分类删除
     */
    testPaperCategoryRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'testPaperCategory/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default TestPaperCategoryService
